// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/range.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/weight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Images/time.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Images/altitude.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Images/speed.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Images/payload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../Images/lunch.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../Images/maxwind.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Ctwo_aw-container__SdOf2 {
  width: 100%;
  height: 100vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("https://i.imgur.com/ksfTplq.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

/* Գլխավոր դիվը էկրանով ամբողջությամբ */
.Ctwo_aw-section-one__ob6We {
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 40px 60px;
}

/* Ձախ ներքևի տեքստ */
.Ctwo_aw-container__SdOf2 h3 {
  font-size: 80px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  color: rgba(255, 255, 255, 0.5019607843);
  opacity: 0.5;
  margin-top: 550px;
}

/* Աջ կողմի նկարը */
.Ctwo_aw-image__m9ZQK {
  width: 1800px;
  height: 750px;
  background-image: url("https://i.imgur.com/U9PCkte.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.Ctwo_sections__ovWUY {
  width: 100%;
  max-width: 1500px;
  margin: auto;
  margin-top: -180px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.Ctwo_sections-child__Lq9\\+A {
  width: 324px;
  height: 225px;
  background-color: white;
  box-shadow: 1px 1px 1px;
  border-bottom: 1px solid;
  border-right: 1px solid;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 40px;
  transform: perspective(1px) translateZ(0);
  box-shadow: 2px 2px 2px transparent;
  transition-duration: 0.3s;
  transition-property: box-shadow, transform;
}

.Ctwo_child-img__KqPWz {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Ctwo_sections-child__Lq9\\+A h2 {
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  color: #4C6D59;
  text-align: center;
}

.Ctwo_sections-child__Lq9\\+A p {
  color: #4C6D59;
  font-weight: 500;
  font-size: 25.5px;
  line-height: 100%;
}

.Ctwo_weight-img__9ZsAH {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Ctwo_time-img__G-7EY {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Ctwo_altitude-img__rJS\\+G {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Ctwo_speed-img__mrg-w {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Ctwo_payload-img__ONOHj {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Ctwo_lunch-img__CawRF {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Ctwo_landing-img__bKoGO {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Ctwo_p-Container__YS1IK {
  width: 80%;
}

.Ctwo_p-Container__YS1IK p {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Ctwo_product-section__T2QtP {
  width: 80%;
  height: 113px;
  display: flex;
  margin: auto;
  background-color: #252626;
  margin-bottom: 100px;
  justify-content: space-around;
  align-items: center;
}

.Ctwo_product-section__T2QtP span {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Ctwo_product-section__T2QtP button {
  width: 300px;
  height: 66px;
  border-radius: 32px;
  border: solid white;
  background-color: #252626;
  color: white;
  font-size: 32px;
  font-weight: 700;
  cursor: pointer;
}

.Ctwo_paragraph-section__8Og1v {
  width: 80%;
  background-color: #4C6D59;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 150px;
}

.Ctwo_paragraph-big__ebgBC {
  width: 100%;
  margin: auto;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 48px;
  position: relative;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
}

.Ctwo_paragraph-big__ebgBC p {
  color: white;
  font-size: 32px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  width: 65%;
  line-height: 1.4;
}

.Ctwo_paragraph-small-container__xPk7M {
  display: flex;
  height: 60%;
  margin-top: 200px;
  flex-direction: column;
  justify-content: space-between;
  margin-left: -70px;
  z-index: 99;
}

.Ctwo_paragraph-small__Are6C {
  width: 149px;
  height: 94px;
  border: 2px solid white;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: white;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
}

@media (max-width: 1000px) {
  .Ctwo_product-section__T2QtP {
    margin-top: -340px;
  }
  .Ctwo_product-section__T2QtP span {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .Ctwo_product-section__T2QtP button {
    font-size: 16px;
    height: 32px;
    width: 100px;
  }
}
@media screen and (max-width: 1024px) {
  .Ctwo_paragraph-big__ebgBC {
    flex-direction: column;
    padding: 30px;
  }
  .Ctwo_paragraph-section__8Og1v {
    max-width: 500px;
    width: 80%;
  }
  .Ctwo_paragraph-big__ebgBC {
    margin-left: -2px;
  }
  .Ctwo_sections-child__Lq9\\+A {
    width: 280px;
    height: 250px;
  }
  .Ctwo_paragraph-big__ebgBC p {
    width: 100%;
    font-size: 24px;
    margin-bottom: 30px;
    text-align: center;
  }
  .Ctwo_paragraph-section__8Og1v {
    height: 500px;
  }
  .Ctwo_p-Container__YS1IK p {
    color: white;
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    font-family: "Roboto", sans-serif;
  }
  .Ctwo_p-Container__YS1IK h2 {
    font-size: 20px;
  }
  .Ctwo_p-Container__YS1IK p {
    font-size: 14px;
  }
  .Ctwo_aw-section-one__ob6We h3 {
    margin-top: 360px;
  }
  .Ctwo_aw-container__SdOf2 {
    height: 800px;
  }
  .Ctwo_sections-child__Lq9\\+A {
    margin: auto;
    margin-bottom: 25px;
  }
  .Ctwo_product-section__T2QtP {
    margin-top: -500px;
    height: 100px;
  }
  .Ctwo_product-section__T2QtP span {
    margin-top: 22px;
  }
  .Ctwo_aw-image__m9ZQK {
    width: 400px;
    height: 185px;
    background-size: cover;
    margin-left: -85px;
    margin-top: -40px;
  }
  .Ctwo_paragraph-small__Are6C {
    width: 130px;
    height: 70px;
    font-size: 14px;
    margin-left: 30px;
  }
}
@media screen and (max-width: 600px) {
  .Ctwo_sections-child__Lq9\\+A {
    width: 150px;
    height: 150px;
  }
  .Ctwo_sections-child__Lq9\\+A h2 {
    font-size: 17px;
    margin-top: 2.5px;
  }
  .Ctwo_sections-child__Lq9\\+A p {
    font-size: 14px;
  }
  .Ctwo_paragraph-section__8Og1v {
    margin-top: 200px;
  }
  .Ctwo_aw-section-one__ob6We h3 {
    margin-top: 180px;
    font-size: 19px;
  }
  .Ctwo_aw-container__SdOf2 {
    height: 60vh;
  }
  .Ctwo_paragraph-big__ebgBC p {
    font-size: 16px;
  }
  .Ctwo_paragraph-small__Are6C {
    width: 110px;
    height: 60px;
    font-size: 12px;
    margin-left: 30px;
  }
  .Ctwo_paragraph-small-container__xPk7M {
    flex-direction: column;
    gap: 16px;
    height: 300px;
  }
  .Ctwo_sections-child__Lq9\\+A {
    width: 145px;
    height: 140px;
  }
  .Ctwo_child-img__KqPWz {
    width: 50px;
    height: 50px;
  }
  .Ctwo_weight-img__9ZsAH {
    width: 50px;
    height: 50px;
  }
  .Ctwo_time-img__G-7EY {
    width: 50px;
    height: 50px;
  }
  .Ctwo_altitude-img__rJS\\+G {
    width: 50px;
    height: 50px;
  }
  .Ctwo_speed-img__mrg-w {
    width: 50px;
    height: 50px;
  }
  .Ctwo_payload-img__ONOHj {
    width: 50px;
    height: 50px;
  }
  .Ctwo_lunch-img__CawRF {
    width: 50px;
    height: 50px;
  }
  .Ctwo_landing-img__bKoGO {
    width: 50px;
    height: 50px;
  }
}
@media screen and (max-width: 530px) {
  .Ctwo_paragraph-big__ebgBC p {
    font-size: 12px;
  }
  .Ctwo_paragraph-small-container__xPk7M {
    margin-top: 160px;
  }
  .Ctwo_paragraph-big__ebgBC {
    height: 500px;
  }
}
@media screen and (min-width: 1025px) {
  .Ctwo_aw-section-one__ob6We h3 {
    font-size: 68px;
    margin-top: 600px;
  }
}
.Ctwo_sections-child__Lq9\\+A:hover,
.Ctwo_sections-child__Lq9\\+A:focus,
.Ctwo_sections-child__Lq9\\+A:active {
  cursor: pointer;
  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);
  transform: scale(1.2);
}`, "",{"version":3,"sources":["webpack://./src/AWC2/Ctwo.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EAEA,kHAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;AACF;;AAEA,uCAAA;AACA;EACE,aAAA;EACA,8BAAA;EAEA,YAAA;EACA,WAAA;EACA,kBAAA;AAAF;;AAGA,qBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;AAAF;;AAGA,mBAAA;AACA;EACE,aAAA;EACA,aAAA;EACA,wDAAA;EACA,wBAAA;EACA,4BAAA;AAAF;;AAIA;EACE,WAAA;EACA,iBAAA;EAGA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,yBAAA;EACA,0CAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AAJF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAcA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAXF;;AAgBA;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;AAbF;;AAkBA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAfF;;AAkBA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAfF;;AAkBA;EACE,UAAA;EAEA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,0CAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAhBF;;AAqBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;EACA,gBAAA;AAlBF;;AAsBA;EAEE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;EAIA,kBAAA;EACA,WAAA;AAvBF;;AA4BA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;EACA,6BAAA;AAzBF;;AA8BA;EAGE;IACE,kBAAA;EA7BF;EAgCA;IACE,eAAA;IACA,mBAAA;EA9BF;EAkCA;IACE,eAAA;IACA,YAAA;IACA,YAAA;EAhCF;AACF;AAoCA;EACE;IACE,sBAAA;IACA,aAAA;EAlCF;EAsCA;IACE,gBAAA;IACA,UAAA;EApCF;EAyCA;IAEE,iBAAA;EAxCF;EA2CA;IACE,YAAA;IACA,aAAA;EAzCF;EA4CA;IACE,WAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EA1CF;EA6CA;IACE,aAAA;EA3CF;EA6CA;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,iCAAA;EA3CF;EA6CA;IACE,eAAA;EA3CF;EAgDA;IACE,eAAA;EA9CF;EAkDA;IAEE,iBAAA;EAjDF;EAsDA;IACE,aAAA;EApDF;EA8DA;IACE,YAAA;IACA,mBAAA;EA5DF;EAgEA;IACE,kBAAA;IACA,aAAA;EA9DF;EAiEA;IACE,gBAAA;EA/DF;EAkEA;IAEE,YAAA;IACA,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,iBAAA;EAjEF;EAqEA;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAnEF;AACF;AAsEA;EAEE;IACE,YAAA;IACA,aAAA;EArEF;EAwEA;IACE,eAAA;IACA,iBAAA;EAtEF;EAyEA;IACE,eAAA;EAvEF;EA0EA;IACE,iBAAA;EAxEF;EA+EA;IAEE,iBAAA;IACA,eAAA;EA9EF;EAgFA;IACE,YAAA;EA9EF;EAiFA;IACE,eAAA;EA/EF;EAkFA;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAhFF;EAqFA;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EAnFF;EAuFA;IACE,YAAA;IACA,aAAA;EArFF;EAuFA;IACE,WAAA;IACA,YAAA;EArFF;EAwFA;IACE,WAAA;IACA,YAAA;EAtFF;EAyFA;IACE,WAAA;IACA,YAAA;EAvFF;EA0FA;IACE,WAAA;IACA,YAAA;EAxFF;EA2FA;IACE,WAAA;IACA,YAAA;EAzFF;EA4FA;IACE,WAAA;IACA,YAAA;EA1FF;EA4FA;IACE,WAAA;IACA,YAAA;EA1FF;EA4FA;IACE,WAAA;IACA,YAAA;EA1FF;AACF;AA+FA;EACE;IACE,eAAA;EA7FF;EAgGA;IACE,iBAAA;EA9FF;EAiGA;IACE,aAAA;EA/FF;AACF;AAoGA;EACE;IAEE,eAAA;IACA,iBAAA;EAnGF;AACF;AA4GA;;;EAGE,eAAA;EACA,mDAAA;EACA,qBAAA;AA1GF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.aw-container {\n  width: 100%;\n  height: 100vh;\n  //background-color: #252626;\n  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(\"https://i.imgur.com/ksfTplq.jpeg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n}\n\n/* Գլխավոր դիվը էկրանով ամբողջությամբ */\n.aw-section-one {\n  display: flex;\n  justify-content: space-between;\n  //align-items: flex-end;\n  height: 100%;\n  width: 100%;\n  padding: 40px 60px;\n}\n\n/* Ձախ ներքևի տեքստ */\n.aw-container h3 {\n  font-size: 80px;\n  font-weight: 700;\n  font-family: 'Roboto', sans-serif;\n  color: #FFFFFF80;\n  opacity: 0.5;\n  margin-top: 550px;\n}\n\n/* Աջ կողմի նկարը */\n.aw-image {\n  width: 1800px;\n  height: 750px;\n  background-image: url(\"https://i.imgur.com/U9PCkte.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  //background-position: center;\n}\n\n.sections {\n  width: 100%;\n  max-width: 1500px;\n  //height: 70vh;\n  //background-color: red;\n  margin: auto;\n  margin-top: -180px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.sections-child {\n  width: 324px;\n  height: 225px;\n  background-color: white;\n  box-shadow: 1px 1px 1px;\n  //display: flex;\n  border-bottom: 1px solid;\n  border-right: 1px solid;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 40px;\n  transform: perspective(1px) translateZ(0);\n  box-shadow: 2px 2px 2px transparent;\n  transition-duration: 0.3s;\n  transition-property: box-shadow, transform;\n}\n\n.child-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/range.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.sections-child h2 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 100%;\n  color: #4C6D59;\n  text-align: center;\n}\n\n.sections-child p {\n  color: #4C6D59;\n  font-weight: 500;\n  font-size: 25.5px;\n  line-height: 100%;\n}\n\n.weight-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/weight.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.time-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/time.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n\n.altitude-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/altitude.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.speed-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/speed.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.payload-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/payload.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.lunch-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/lunch.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.landing-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/maxwind.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.p-Container {\n  width: 80%;\n  //display: flex;\n\n  //justify-content: center;\n  //align-items: center;\n  //text-align: center;\n\n}\n\n.p-Container p{\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n\n\n.product-section {\n  width: 80%;\n  height: 113px;\n  display: flex;\n  margin: auto;\n  background-color: #252626;\n  margin-bottom: 100px;\n  justify-content: space-around;\n  align-items: center;\n\n\n}\n\n.product-section span {\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.product-section button {\n  width: 300px;\n  height: 66px;\n  border-radius: 32px;\n  border: solid white;\n  background-color: #252626;\n  color: white;\n  font-size: 32px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.paragraph-section {\n  width: 80%;\n  //height: 70vh;\n  background-color: #4C6D59;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  margin-top: 100px;\n  margin-bottom: 150px;\n}\n\n.paragraph-big {\n  width: 100%;\n  margin: auto;\n  padding: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  background-color: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 48px;\n  position: relative;\n  margin-top: 100px;\n  margin-bottom: 100px;\n  text-align: center;\n\n\n}\n\n.paragraph-big p {\n  color: white;\n  font-size: 32px;\n  font-weight: 500;\n  font-family: 'Roboto', sans-serif;\n  width: 65%;\n  line-height: 1.4;\n\n}\n\n.paragraph-small-container {\n  //width: 30%;\n  display: flex;\n  height: 60%;\n  margin-top: 200px;\n  flex-direction: column;\n  justify-content: space-between;\n  //align-items: flex-end;\n  //background-color: red;\n  //position: absolute;\n  margin-left: -70px;\n  z-index: 99;\n\n\n}\n\n.paragraph-small {\n  width: 149px;\n  height: 94px;\n  border: 2px solid white;\n  border-radius: 19px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  font-family: 'Roboto', sans-serif;\n  background-color: transparent;\n\n}\n\n\n@media (max-width: 1000px) {\n\n\n  .product-section{\n    margin-top: -340px;\n  }\n\n  .product-section span {\n    font-size: 16px;\n    margin-bottom: 20px;\n\n  }\n\n  .product-section button {\n    font-size: 16px;\n    height: 32px;\n    width:100px;\n\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .paragraph-big {\n    flex-direction: column;\n    padding: 30px;\n    //height: 50vh;\n\n  }\n  .paragraph-section {\n    max-width: 500px;\n    width: 80%;\n\n    //margin: auto;\n    //background-color: red;\n  }\n  .paragraph-big {\n    //background-color: red;\n    margin-left: -2px;\n  }\n\n  .sections-child {\n    width: 280px;\n    height: 250px;\n  }\n\n  .paragraph-big p {\n    width: 100%;\n    font-size: 24px;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n  .paragraph-section{\n    height: 500px;\n  }\n  .p-Container p{\n    color: white;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 100%;\n    font-family: 'Roboto', sans-serif;\n  }\n  .p-Container h2{\n    font-size: 20px;\n  }\n\n\n\n  .p-Container p{\n    font-size: 14px;\n  }\n\n\n  .aw-section-one h3 {\n    //background-color: red;\n    margin-top: 360px;\n    //font-size: 19px;\n\n  }\n\n  .aw-container {\n    height: 800px;\n  }\n\n  //.paragraph-small-container {\n  //  margin: 0 auto;\n  //  flex-direction: row;\n  //  justify-content: center;\n  //  gap: 20px;\n  //  height: auto;\n  //}\n  .sections-child {\n    margin: auto;\n    margin-bottom: 25px;\n  }\n\n\n  .product-section {\n    margin-top: -500px;\n    height: 100px;\n  }\n\n  .product-section span{\n    margin-top: 22px;\n  }\n\n  .aw-image {\n    //margin: auto;\n    width: 400px;\n    height: 185px;\n    background-size: cover;\n    margin-left: -85px;\n    margin-top: -40px;\n\n  }\n\n  .paragraph-small {\n    width: 130px;\n    height: 70px;\n    font-size: 14px;\n    margin-left: 30px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .sections-child{\n    width: 150px;\n    height: 150px;\n  }\n\n  .sections-child h2{\n    font-size: 17px;\n    margin-top: 2.5px;\n  }\n\n  .sections-child p{\n    font-size: 14px;\n  }\n\n  .paragraph-section {\n    margin-top: 200px;\n\n  }\n\n\n\n\n  .aw-section-one h3 {\n    //background-color: red;\n    margin-top: 180px;\n    font-size: 19px;\n  }\n  .aw-container {\n    height: 60vh;\n  }\n\n  .paragraph-big p {\n    font-size: 16px;\n  }\n\n  .paragraph-small {\n    width: 110px;\n    height: 60px;\n    font-size: 12px;\n    margin-left: 30px;\n\n\n  }\n\n  .paragraph-small-container {\n    flex-direction: column;\n    gap: 16px;\n    height: 300px;\n  }\n\n\n  .sections-child{\n    width: 145px;\n    height: 140px;\n  }\n  .child-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .weight-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .time-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .altitude-img{\n    width: 50px;\n    height: 50px;\n\n  }\n  .speed-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .payload-img{\n    width: 50px;\n    height: 50px;\n  }\n  .lunch-img{\n    width: 50px;\n    height: 50px;\n  }\n  .landing-img{\n    width: 50px;\n    height: 50px;\n  }\n\n}\n\n\n@media screen and (max-width: 530px) {\n  .paragraph-big p {\n    font-size: 12px;\n  }\n\n  .paragraph-small-container {\n    margin-top: 160px;\n    //margin-left: 2px;\n  }\n  .paragraph-big {\n    height: 500px;\n  }\n\n}\n\n\n@media screen and (min-width: 1025px) {\n  .aw-section-one h3 {\n    //background-color: red;\n    font-size: 68px;\n    margin-top: 600px;\n  }\n  //.aw-container{\n  //  height: 50vh;\n  //}\n\n\n}\n\n\n.sections-child:hover,\n.sections-child:focus,\n.sections-child:active {\n  cursor: pointer;\n  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);\n  transform: scale(1.2);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aw-container": `Ctwo_aw-container__SdOf2`,
	"aw-section-one": `Ctwo_aw-section-one__ob6We`,
	"aw-image": `Ctwo_aw-image__m9ZQK`,
	"sections": `Ctwo_sections__ovWUY`,
	"sections-child": `Ctwo_sections-child__Lq9+A`,
	"child-img": `Ctwo_child-img__KqPWz`,
	"weight-img": `Ctwo_weight-img__9ZsAH`,
	"time-img": `Ctwo_time-img__G-7EY`,
	"altitude-img": `Ctwo_altitude-img__rJS+G`,
	"speed-img": `Ctwo_speed-img__mrg-w`,
	"payload-img": `Ctwo_payload-img__ONOHj`,
	"lunch-img": `Ctwo_lunch-img__CawRF`,
	"landing-img": `Ctwo_landing-img__bKoGO`,
	"p-Container": `Ctwo_p-Container__YS1IK`,
	"product-section": `Ctwo_product-section__T2QtP`,
	"paragraph-section": `Ctwo_paragraph-section__8Og1v`,
	"paragraph-big": `Ctwo_paragraph-big__ebgBC`,
	"paragraph-small-container": `Ctwo_paragraph-small-container__xPk7M`,
	"paragraph-small": `Ctwo_paragraph-small__Are6C`
};
export default ___CSS_LOADER_EXPORT___;
